import { useLocation, useNavigate } from 'react-router-dom';
import GpanelContactsLabelsItem from './gpanel-contacts-labels/gpanel-contacts-labels-item';
import { GPanelContactsPagesConfig } from '../shared/pages-config';
import { useState } from 'react';
import {
  useLabelGroupsQuery,
  useTrashLabelsQuery,
} from '../gpanel-contacts-queries';

import Collapse from '@mui/material/Collapse';
import Icon from '@mui/material/Icon';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowRight from '@mui/icons-material/ArrowRight';
import DeleteOutline from '@mui/icons-material/DeleteOutline';

export default function GpanelContactsTrashNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = useLabelGroupsQuery();
  const { data: trashedLabels = [] } = useTrashLabelsQuery();

  const pathSegments = location.pathname.split('/');
  const trashType = pathSegments[2];

  const selectedTrashType =
    {
      [GPanelContactsPagesConfig.TrashContacts.link]:
        GPanelContactsPagesConfig.TrashContacts.value,
      [GPanelContactsPagesConfig.TrashLabels.link]:
        GPanelContactsPagesConfig.TrashLabels.value,
    }[trashType] ?? null;
  const [open, setOpen] = useState(Boolean(selectedTrashType));

  return (
    <List
      sx={{
        pt: 0,
        '& .MuiListItemButton-root': {
          borderRadius: 2,
        },
      }}
    >
      <ListItemButton
        onClick={() => setOpen((open) => !open)}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          ml: '8px',
          pl: '8px',
        }}
      >
        {open ? <ArrowDropDown /> : <ArrowRight />}
        <DeleteOutline />
        <ListItemText
          primary={'Trash'}
          slotProps={{
            primary: {
              sx: {
                fontWeight: 400,
                ml: 0.75,
              },
            },
          }}
        />
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" sx={{ pl: 2, mb: 2 }} disablePadding>
          <GpanelContactsLabelsItem
            label={GPanelContactsPagesConfig.TrashContacts.name}
            icon={<Icon />}
            count={data?.trashedContactsCount}
            selected={
              selectedTrashType ===
              GPanelContactsPagesConfig.TrashContacts.value
            }
            onClick={() =>
              navigate(`./${GPanelContactsPagesConfig.TrashContacts.link}`)
            }
          />
          <GpanelContactsLabelsItem
            label={GPanelContactsPagesConfig.TrashLabels.name}
            icon={<Icon />}
            count={trashedLabels.length}
            selected={
              selectedTrashType === GPanelContactsPagesConfig.TrashLabels.value
            }
            onClick={() =>
              navigate(`./${GPanelContactsPagesConfig.TrashLabels.link}`)
            }
          />
        </List>
      </Collapse>
    </List>
  );
}
